export default {
  RotatingBannerPanel__ARIA_LABEL: "The current page is",
  RotatingBannerPanel__ARIA_LABEL_NEXT: "Press this button to display the next item.",
  RotatingBannerPanel__ARIA_LABEL_PREVIOUS: "Press this button to display the previous item.",
};
